module.exports = __webpack_public_path__ + "static/media/swap-dark.fb35f794.svg";